import { isEmpty } from "lodash";
import React from "react";
import { useTranslation } from "react-i18next";
import { FORM_NAME, SIMULATION_MODES, SIMULATION_TYPE } from "src/constant/common";
import { getFileUploadName } from "src/utils/common";

const ModalViewMainTab = ({ simulationData }) => {
  const { t } = useTranslation("gnc-simulator-6dof");
  return (
    <div className="m-3">
      <div className="fw-bold mb-3">
        <span className="text-capitalize">{t("new.main.simulation_name")}: </span>
        <span className="text-break">{simulationData?.name}</span>
      </div>
      <div className="fw-bold mb-3">
        <span className="text-capitalize">{t("new.main.type")}: </span>
        <span className="text-break">
          {simulationData?.type === SIMULATION_TYPE.GNC_6DoF_MCS ? SIMULATION_MODES.MCS : SIMULATION_MODES.SIM}
        </span>
      </div>
      {simulationData?.type === SIMULATION_TYPE.GNC_6DoF_MCS && (
        <div className="fw-bold mb-3">
          <span className="text-capitalize">{t("new.MCS.number_of_samples")}: </span>
          <span className="text-break">{simulationData?.input_data?.MCS?.number_of_samples?.value}</span>
        </div>
      )}
      <div className="fw-bold mb-3">
        <span className="text-capitalize">{t("new.main.user_name")}: </span>
        <span className="text-break">{simulationData?.updated_by}</span>
      </div>
      <div className="fw-bold mb-3">
        <span className="text-capitalize">{t(`new.main.${FORM_NAME.VERSION}`)}: </span>
        <span className="text-break">{simulationData?.version_name}</span>
      </div>
      <div className="fw-bold mb-3">
        <span className="text-capitalize">{t(`new.main.${FORM_NAME.NOTE}`)}: </span>
        <br />
        <span className="text-break">{simulationData?.note}</span>
      </div>
      <div className="mb-3">
        <span className="fw-bold">{t("new.main.aerodynamic_coefficients")}: </span>
        <br />
        <a href={simulationData?.series?.aerodynamic_coefficients_url} className="fw-bold link-primary text-break">
          {getFileUploadName(simulationData?.series?.aerodynamic_coefficients_path)}
        </a>
      </div>
      <div className="fw-bold mb-3">
        <span className="text-capitalize">{t(`new.main.${FORM_NAME.MAIN.SIMULATION_TIME}`)}</span>
        {" (s): "}
        <span className="text-break">{simulationData?.input_data?.main?.simulation_time?.value}</span>
      </div>
      <div className="fw-bold mb-3">
        <span className="text-capitalize">{t("new.main.reference_note")}: </span>
        <div>
          {!isEmpty(simulationData?.parent) ? (
            <span className="text-break">{`${t("new.main.simulation_copy")} SimID ${simulationData?.parent?.id} (${
              simulationData?.parent?.name
            })`}</span>
          ) : (
            <span>{t("new.main.root_simulation")}</span>
          )}
        </div>
      </div>
    </div>
  );
};

export default ModalViewMainTab;
